// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"e569c1ce","789":"addd1091"}[chunkId] + ".chunk.js";
};